import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

import { hasValue } from "../../../../../src/Helpers/validations/common";
import { displayDate } from "../../../../../src/Helpers/utils/utils";
import { WebRoutes } from "../../../../Constants";

function IddinkEmployeeHomeExtra() {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const normalColumns = [
        {
            name: "logisticId",
            headerCaption: t("Linked"),
            textAlign: "center",
            size: "small-s",
            canSort: true,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                const icon =
                    hasValue(x.barcode) || hasValue(x.barcodeReturn) ? (
                        <span className="icon checked">check_circle</span>
                    ) : (
                        <span className="icon">radio_button_unchecked</span>
                    );

                return (
                    <div className="logistic-column-wrapper">
                        <span className="logisticId-wrapper">{icon}</span>
                        {(hasValue(x.barcode) || hasValue(x.barcodeReturn)) && (
                            <span
                                title={
                                    x.isManuallyMapped
                                        ? t("ThisPackageIsManuallyMapped")
                                        : t("ThisPackageIsAutomaticallyMapped")
                                }
                                className={`mapped-type ${x.isManuallyMapped ? "manual" : "auto"
                                    }`}
                            >
                                {x.isManuallyMapped ? t("Manual") : t("Auto")}
                            </span>
                        )}
                    </div>
                );
            },
        },
        {
            name: "lines",
            headerCaption: t("MappedLines"),
            textAlign: "center",
            size: "small-s",
            canSort: true,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                const totalLines = x.lines.length;
                const mappedLines = x.lines.filter(
                    (l) => l.barcodeBook !== null
                ).length;

                const completed = mappedLines === totalLines;
                return (
                    <div className="lines-count-wrapper">
                        <div
                            className={`lines-count ${completed ? "completed" : "not-completed"
                                }`}
                        >
                            {`${mappedLines}/${totalLines}`}
                        </div>
                    </div>
                );
            },
        },
        {
            name: "lines",
            headerCaption: t("MappedBooks"),
            textAlign: "center",
            size: "small-s",
            canSort: true,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                const totalLines = x.barcode?.barcodeBooks?.length ?? 0;
                const mappedLines = x.lines.filter(
                    (l) => l.barcodeBook !== null
                ).length;

                const completed = mappedLines === totalLines && x.barcode;
                return (
                    <div className="lines-count-wrapper">
                        <div
                            className={`lines-count ${completed ? "completed" : "not-completed"
                                }`}
                        >
                            {`${mappedLines}/${totalLines}`}
                        </div>
                    </div>
                );
            },
        },
        {
            name: "receiptDate",
            headerCaption: t("ReceiptDate"),
            caption: (x) => displayDate(new Date(x.receiptDate).toString()),
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "vendorShipmentNo",
            headerCaption: t("VendorShipmentNo"),
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "school.schoolNumber",
            headerCaption: t("SchoolNumber"),
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "inbound.senderName",
            headerCaption: t("SenderName"),
            filterName: "logisticInbound.senderName",
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "saved",
            headerCaption: t("Saved"),
            size: "small",
            textAlign: "center",
            canSort: false,
            canFilter: false,
            canEdit: false,
            caption: (x) => (
                <span className="is-checkbox">
                    {x.isMappedSaved ? "check_box" : "check_box_outline_blank"}
                </span>
            ),
        },
        {
            name: "exported",
            headerCaption: t("Exported"),
            size: "small",
            textAlign: "center",
            canSort: false,
            canFilter: false,
            canEdit: false,
            caption: (x) => (
                <span className="is-checkbox">
                    {x.isMappedExported ? "check_box" : "check_box_outline_blank"}
                </span>
            ),
        },
        {
            name: "actions",
            headerCaption: "",
            size: "small",
            textAlign: "right",
            canSort: false,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                return (
                    <Button
                        className="button-view"
                        onClick={() => {
                            navigate(WebRoutes.LogisticsPackage.replace(":id", x.id));
                        }}
                    >
                        {t("View")}
                    </Button>
                );
            },
        },
    ]

    const returnsColumns = [
        {
            name: "logisticId",
            headerCaption: t("Linked"),
            textAlign: "center",
            size: "small-s",
            canSort: true,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                const icon =
                    hasValue(x.barcode) || hasValue(x.barcodeReturn) ? (
                        <span className="icon checked">check_circle</span>
                    ) : (
                        <span className="icon">radio_button_unchecked</span>
                    );

                return (
                    <div className="logistic-column-wrapper">
                        <span className="logisticId-wrapper">{icon}</span>
                        {(hasValue(x.barcode) || hasValue(x.barcodeReturn)) && (
                            <span
                                title={
                                    x.isManuallyMapped
                                        ? t("ThisPackageIsManuallyMapped")
                                        : t("ThisPackageIsAutomaticallyMapped")
                                }
                                className={`mapped-type ${x.isManuallyMapped ? "manual" : "auto"
                                    }`}
                            >
                                {x.isManuallyMapped ? t("Manual") : t("Auto")}
                            </span>
                        )}
                    </div>
                );
            },
        },
        {
            name: "lines",
            headerCaption: t("MappedLines"),
            textAlign: "center",
            size: "small-s",
            canSort: true,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                const totalLines = x.lines.length;
                const mappedLines = x.lines.filter(
                    (l) => l.barcodeReturnLine !== null
                ).length;

                const completed = mappedLines === totalLines;
                return (
                    <div className="lines-count-wrapper">
                        <div
                            className={`lines-count ${completed ? "completed" : "not-completed"
                                }`}
                        >
                            {`${mappedLines}/${totalLines}`}
                        </div>
                    </div>
                );
            },
        },
        {
            name: "lines",
            headerCaption: t("ReturnLines"),
            textAlign: "center",
            size: "small-s",
            canSort: true,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                const totalLines = x.barcodeReturn?.lines?.length ?? 0;
                const mappedLines = x.lines.filter(
                    (l) => l.barcodeReturnLine !== null
                ).length;

                const completed = mappedLines === totalLines && x.barcodeReturn;
                return (
                    <div className="lines-count-wrapper">
                        <div
                            className={`lines-count ${completed ? "completed" : "not-completed"
                                }`}
                        >
                            {`${mappedLines}/${totalLines}`}
                        </div>
                    </div>
                );
            },
        },
        {
            name: "receiptDate",
            headerCaption: t("ReceiptDate"),
            caption: (x) => displayDate(new Date(x.receiptDate).toString()),
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "vendorShipmentNo",
            headerCaption: t("VendorShipmentNo"),
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "school.schoolNumber",
            headerCaption: t("SchoolNumber"),
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "inbound.senderName",
            headerCaption: t("SenderName"),
            filterName: "logisticInbound.senderName",
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "saved",
            headerCaption: t("Saved"),
            size: "small",
            textAlign: "center",
            canSort: false,
            canFilter: false,
            canEdit: false,
            caption: (x) => (
                <span className="is-checkbox">
                    {x.isMappedSaved ? "check_box" : "check_box_outline_blank"}
                </span>
            ),
        },
        {
            name: "actions",
            headerCaption: "",
            size: "small",
            textAlign: "right",
            canSort: false,
            canFilter: false,
            canEdit: false,
            caption: (x) => {
                return (
                    <Button
                        className="button-view"
                        onClick={() => {
                            navigate(WebRoutes.LogisticsPackage.replace(":id", x.id));
                        }}
                    >
                        {t("View")}
                    </Button>
                );
            },
        },
    ]

    const searchParams = {
        barcodeIsLinked: "barcodeIsLinked",
        returns: "returns",
        disabled: "Disabled",
        vendorShipmentNo: "vendorShipmentNo"
    };

    return { normalColumns, returnsColumns, searchParams }
}

export default IddinkEmployeeHomeExtra;